<template lang="pug">
.work-break-policies-table-component
  .table-wrapper.mt-0
    .scrollable
      table.table-work-break-policies.has-actions.table-hover.table
        thead
          tr
            th Policy name
            th Members
            th Type
            th
        tbody
          tr(
            v-for="workBreakPolicy in allWorkBreakPolicies"
            :key="workBreakPolicy.id"
            @mouseover="setHover(workBreakPolicy.id, true)"
            @mouseleave="setHover(workBreakPolicy.id, false)"
          )
            td
              span {{ workBreakPolicy.name }}
            td(v-if="isActivePolicy(workBreakPolicy)")
              a.align-items-center.a-tooltip.members-link(@click="onEditClick(workBreakPolicy)")
                AppAvatar.avatar-overlaps(
                  v-for="(member, index) in workBreakPolicyMembers(workBreakPolicy)"
                  :key="index"
                  v-tooltip="tooltipOptions"
                  avatar-style="medium"
                  :avatar="member.avatar_url"
                  :title="member.name"
                )
                span.more-members-badge.light(v-if="showMoreBadge(workBreakPolicy)") +{{ workBreakPolicy.members.length - 3 }}
                span(v-if="workBreakPolicy.members.length == 0") No members
                i.hi.hi-edit-xs.mx-5(
                  v-tooltip="tooltipOptions"
                  :style="{ color: isEditIconVisible(workBreakPolicy.id) ? '' : 'transparent' }"
                  title="Edit members"
                )
            td(v-else)
              | {{ workBreakPolicy.members.length || 0 }}
            td
              span {{ formatPaid(workBreakPolicy) }}
            td
              .dropdown.table-actions-dropdown.work-break-policies-action-dropdown
                a.btn.btn-sm.btn-default.dropdown-toggle(
                  href="#"
                  data-toggle="dropdown"
                  role="button"
                )
                  | Actions
                  i.hi.hi-caret.hi-10
                ul.dropdown-menu.dropdown-menu-right
                  template(v-if="isActivePolicy(workBreakPolicy)")
                    li
                      a(@click="onEditClick(workBreakPolicy)")
                        | Edit policy
                    li
                      a(@click="archivePolicy(workBreakPolicy)")
                        | Archive policy
                  template(v-else)
                    li
                      a(@click="restorePolicy(workBreakPolicy)")
                        | Restore policy
  AppPagination(
    v-if="allWorkBreakPolicies.length > 0"
    :pagination="pagination"
    :resource="{ one: 'policy', many: 'policies' }"
    @page-changed="onPageChanged"
  )
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'WorkBreakPoliciesTable',
  data: () => ({
    tooltipOptions: Object.freeze({ placement: 'bottom' }),
    hoverStates: {},
  }),
  computed: {
    ...mapGetters(['allWorkBreakPolicies', 'pagination']),
  },
  methods: {
    ...mapActions(['archiveWorkBreakPolicy', 'restoreWorkBreakPolicy']),
    formatPaid(workBreakPolicy) {
      if (workBreakPolicy.paid) {
        return 'Paid';
      }

      return 'Unpaid';
    },
    onPageChanged(page) {
      this.$emit('page-changed', page);
    },
    isActivePolicy(workBreakPolicy) {
      return workBreakPolicy.status === 0;
    },
    onEditClick(workBreakPolicy) {
      this.$emit('edit-button-clicked', workBreakPolicy);
    },
    archivePolicy(workBreakPolicy) {
      if (confirm('Are you sure you want to archive this policy?')) {
        const isLastPolicyOnPage = this.allWorkBreakPolicies.length === 1

        this.archiveWorkBreakPolicy({ workBreakPolicyId: workBreakPolicy.id, isLastPolicyOnPage }).then(
          (response) => {
            if (response.success) {
              this.$appMessage('Policy archived');
            } else {
              this.$appMessage(response.errors.work_break_policy);
            }
          },
          (response) => {
            this.$appMessage('Unexpected error. Please try again.');
          },
        );
      }
    },
    restorePolicy(workBreakPolicy) {
      if (confirm('Are you sure you want to restore this policy?')) {
        const isLastPolicyOnPage = this.allWorkBreakPolicies.length === 1

        this.restoreWorkBreakPolicy({ workBreakPolicyId: workBreakPolicy.id, isLastPolicyOnPage }).then(
          (response) => {
            if (response.success) {
              this.$appMessage('Policy restored');
            } else {
              this.$appMessage(response.errors.work_break_policy);
            }
          },
          (response) => {
            this.$appMessage('Unexpected error. Please try again.');
          },
        );
      }
    },
    workBreakPolicyMembers(workBreakPolicy) {
      return (workBreakPolicy.members || []).slice(0, 3);
    },
    showMoreBadge(workBreakPolicy) {
      return (workBreakPolicy.members || []).length > 3;
    },
    setHover(id, state) {
      this.hoverStates[id] = state;
    },
    isEditIconVisible(id) {
      return !!this.hoverStates[id];
    },
  },
};
</script>
